<template>
  <div>
    <div>
      <div class="max-w-5xl mx-auto">
        <div
          class="flex flex-wrap items-center justify-between -mt-2 -ml-4 sm:flex-no-wrap"
        >
          <div class="mt-2 ml-4">
            <h3 class="text-lg font-medium leading-6 text-gray-900">
              Ordini
            </h3>
            <p
              v-if="showAlert"
              class="flex items-center p-1 text-xs bg-red-100 border-gray-300 rounded-lg"
            >
              <svg
                class="w-4 h-4 mr-1 text-red-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
              <span class="mr-1"
                >Non hai attiva nessuna modalità di ordinazione.
              </span>
              <router-link
                :to="{
                  name: 'OrdersSettingsDelivery',
                  params: { id: this.id },
                }"
                class="font-semibold text-indigo-600"
              >
                Attiva ora</router-link
              >
            </p>
          </div>
          <div class="flex-shrink-0 mt-2 ml-4">
            <span class="inline-flex rounded-md shadow-sm">
              <router-link
                :to="{
                  name: 'OrdersSettingsDelivery',
                  params: { id: this.id },
                }"
                type="button"
                class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-white bg-green-400 border rounded-md shadow-sm border-gray-50 hover:text-gray-50 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5 hover:bg-green-500 focus:border-green-400 focus:shadow-outline-green"
              >
                Impostazioni ordini
              </router-link>
            </span>
          </div>
        </div>
      </div>

      <div class="max-w-5xl mx-auto mt-5">
        <div class="px-0 py-4 bg-white rounded-md shadow-sm">
          <div class="flex justify-between pb-4 border-b ">
            <div class="ml-4 sm:hidden">
              <select
                @change="$router.push({ name: $event.target.value })"
                aria-label="Selected tab"
                class="block w-full form-select"
              >
                <option
                  :selected="this.$route.name == 'OrdersHistory'"
                  value="OrdersHistory"
                  >Ordini da approvare</option
                >
                <option
                  v-show="isActive('domicilio')"
                  :selected="this.$route.name == 'OrdersHistoryDelivery'"
                  value="OrdersHistoryDelivery"
                  >Consegna a domicilio</option
                >
                <option
                  v-show="isActive('asporto')"
                  :selected="this.$route.name == 'OrdersHistoryTakeAway'"
                  value="OrdersHistoryTakeAway"
                  >Asporto</option
                >
                <option
                  v-show="isActive('tavolo')"
                  :selected="this.$route.name == 'OrdersHistoryTable'"
                  value="OrdersHistoryTable"
                  >Tavolo</option
                >
                <option
                  :selected="this.$route.name == 'OrdersHistoryUmbrella'"
                  value="OrdersHistoryUmbrella"
                  v-show="isActive('umbrella')"
                  >Ombrellone</option
                >
                <option
                  v-show="isActive('tavolo-hotel')"
                  :selected="this.$route.name == 'OrdersHistoryHotel'"
                  value="OrdersHistoryHotel"
                  >Hotel</option
                >
                <option
                  v-show="isActive('roomservice')"
                  :selected="this.$route.name == 'OrdersHistoryRoomService'"
                  value="OrdersHistoryRoomService"
                  >Room Service</option
                >
              </select>
            </div>
            <div class="hidden sm:block">
              <nav class="flex ">
                <router-link
                  :to="{ name: 'OrdersHistory' }"
                  class="px-3 py-2 ml-4 text-sm font-medium leading-5 text-gray-600 rounded-md focus:outline-none focus:text-indigo-800"
                >
                  Ordini da approvare
                </router-link>
                <router-link
                  v-show="isActive('domicilio')"
                  :to="{ name: 'OrdersHistoryDelivery' }"
                  class="px-3 py-2 ml-4 text-sm font-medium leading-5 text-gray-600 rounded-md focus:outline-none focus:text-indigo-800"
                >
                  Consegna a domicilio
                </router-link>
                <router-link
                  v-show="isActive('asporto')"
                  :to="{ name: 'OrdersHistoryTakeAway' }"
                  class="px-3 py-2 ml-4 text-sm font-medium leading-5 text-gray-600 rounded-md focus:outline-none focus:text-indigo-800"
                >
                  Asporto
                </router-link>
                <router-link
                  v-show="isActive('tavolo')"
                  :to="{ name: 'OrdersHistoryTable' }"
                  class="px-3 py-2 ml-4 text-sm font-medium leading-5 text-gray-600 rounded-md focus:outline-none focus:text-indigo-800"
                >
                  Tavolo
                </router-link>
                <router-link
                  v-show="isActive('umbrella')"
                  :to="{ name: 'OrdersHistoryUmbrella' }"
                  class="px-3 py-2 ml-4 text-sm font-medium leading-5 text-gray-600 rounded-md focus:outline-none focus:text-indigo-800"
                >
                  Ombrellone
                </router-link>
                <router-link
                  v-show="isActive('tavolo-hotel')"
                  :to="{ name: 'OrdersHistoryHotel' }"
                  class="px-3 py-2 ml-4 text-sm font-medium leading-5 text-gray-600 rounded-md focus:outline-none focus:text-indigo-800"
                >
                  Hotel
                </router-link>
                <router-link
                  v-show="isActive('roomservice')"
                  :to="{ name: 'OrdersHistoryRoomService' }"
                  class="px-3 py-2 ml-4 text-sm font-medium leading-5 text-gray-600 rounded-md focus:outline-none focus:text-indigo-800"
                >
                  Servizio in camera
                </router-link>
              </nav>
            </div>

            <div class="mr-4" v-if="$route.name != 'OrdersHistory'">
              <button
                @click="callChild"
                type="button"
                class="inline-flex items-center px-3 py-2 text-sm font-medium leading-4 text-white transition duration-150 ease-in-out bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700"
              >
                Crea ordine
              </button>
            </div>
          </div>
          <div class="m-4 mb-0">
            <router-view :key="$route.path" ref="childRef"></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderSettings from "../apis/OrderSettings";
export default {
  props: {
    id: Number,
  },

  created() {
    OrderSettings.getOrdersSettings(this.id).then((response) => {
      this.location.orderTypesSettings = response.data;
    });
    console.log("created");
  },

  data() {
    return {
      orderTypesSettings: null,
      location: null,
      showAlert: false,
    };
  },

  computed: {
    isActive() {
      return (slug) => {
        if (this.location == null)
          this.location = this.$store.state.locations.find(
            (l) => l.id == this.id
          );

        if (
          this.location == undefined ||
          this.location.orderTypesSettings == undefined
        ) {
          return false;
        }

        let r = this.location.orderTypesSettings.filter(
          (item) => item.slug == slug && item.enable == 1
        );

        let s = this.location.orderTypesSettings.filter(
          (item) => item.enable == 1
        );

        if (s && s.length == 0) {
          this.showAlert = true;
        } else {
          this.showAlert = false;
        }

        if (r && r.length > 0) {
          return true;
        }

        return false;
        /*
        if (this.orderTypesSettings == null) {
          return false;
        }

        let r = this.orderTypesSettings.filter(
          (item) => item.slug == slug && item.enable == 1
        );

        if (r && r.length > 0) {
          return true;
        }

        return false;
        */
      };
    },
  },
  methods: {
    callChild() {
      this.$refs.childRef.openOrderModal();
    },
  },
};
</script>

<style></style>
